export interface EmojiEntry {
  char: string;
  name: string;
  group: EmojiGroup;
}

export type EmojiGroup = 'Frequent' | 'Smileys' | 'Gestures' | 'Objects' | 'Symbols';

export const EMOJI_GROUPS: readonly EmojiGroup[] = [
  'Frequent',
  'Smileys',
  'Gestures',
  'Objects',
  'Symbols',
];

/**
 * A compact built-in set. Shipping a 1.8 MB emoji-mart dataset to render a
 * picker used a few times a day is exactly the kind of cost this product
 * refuses to pay; the quick set covers the overwhelming majority of reactions.
 */
export const EMOJI: readonly EmojiEntry[] = [
  { char: '👍', name: 'thumbs up', group: 'Frequent' },
  { char: '❤️', name: 'heart', group: 'Frequent' },
  { char: '😂', name: 'joy laugh', group: 'Frequent' },
  { char: '🎉', name: 'party tada celebrate', group: 'Frequent' },
  { char: '🔥', name: 'fire hot', group: 'Frequent' },
  { char: '💯', name: 'hundred perfect', group: 'Frequent' },
  { char: '👀', name: 'eyes looking', group: 'Frequent' },
  { char: '🙏', name: 'thanks pray please', group: 'Frequent' },
  { char: '😀', name: 'grin smile', group: 'Smileys' },
  { char: '😅', name: 'sweat smile', group: 'Smileys' },
  { char: '😊', name: 'blush happy', group: 'Smileys' },
  { char: '😍', name: 'heart eyes love', group: 'Smileys' },
  { char: '🤔', name: 'thinking hmm', group: 'Smileys' },
  { char: '😴', name: 'sleep tired', group: 'Smileys' },
  { char: '😭', name: 'cry sob', group: 'Smileys' },
  { char: '😡', name: 'angry mad', group: 'Smileys' },
  { char: '🥳', name: 'party face celebrate', group: 'Smileys' },
  { char: '😎', name: 'cool sunglasses', group: 'Smileys' },
  { char: '🤝', name: 'handshake deal', group: 'Gestures' },
  { char: '👏', name: 'clap applause', group: 'Gestures' },
  { char: '🙌', name: 'raise hands celebrate', group: 'Gestures' },
  { char: '👋', name: 'wave hello hi', group: 'Gestures' },
  { char: '✌️', name: 'peace victory', group: 'Gestures' },
  { char: '🤞', name: 'fingers crossed luck', group: 'Gestures' },
  { char: '👎', name: 'thumbs down no', group: 'Gestures' },
  { char: '💪', name: 'strong muscle', group: 'Gestures' },
  { char: '🚀', name: 'rocket ship launch', group: 'Objects' },
  { char: '💡', name: 'idea bulb', group: 'Objects' },
  { char: '📌', name: 'pin', group: 'Objects' },
  { char: '📎', name: 'attachment clip', group: 'Objects' },
  { char: '🗓️', name: 'calendar date', group: 'Objects' },
  { char: '💻', name: 'laptop code', group: 'Objects' },
  { char: '☕', name: 'coffee break', group: 'Objects' },
  { char: '🍕', name: 'pizza food', group: 'Objects' },
  { char: '✅', name: 'check done complete', group: 'Symbols' },
  { char: '❌', name: 'cross no wrong', group: 'Symbols' },
  { char: '⚠️', name: 'warning caution', group: 'Symbols' },
  { char: '⭐', name: 'star favourite', group: 'Symbols' },
  { char: '🔗', name: 'link url', group: 'Symbols' },
  { char: '🔒', name: 'lock secure', group: 'Symbols' },
  { char: '⏰', name: 'alarm time', group: 'Symbols' },
  { char: '📈', name: 'chart growth up', group: 'Symbols' },
];

export function searchEmoji(query: string): readonly EmojiEntry[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return EMOJI;
  return EMOJI.filter((entry) => entry.name.includes(needle) || entry.char === needle);
}
